<template>
    <div class="all-box">
        <img src="./imgs/img-logo-icon-img.png" alt="">
        <p>页面出错误了 ~</p>
    </div>
</template>
        
<script>
export default {
   
}
</script>
<style lang='less' scoped>
.all-box{
    width: 100%;
    height: 100%;
    img{
        width: 200px;
        height: 190px;
        margin-top: 300px;
        // margin: 300px 0px;
    }
    p{
        font-size: 24px;
        letter-spacing: 2px;
        color: #000;
        margin-top: 50px;
        margin-bottom: 300px;
    }
}
</style>